export const buildNavigation = ({ hasDesconto, hasCashback, hasPromocaoNacional, isReadonly, storeName } = {}) => ({
  sections: [
    {
      key: 'meu-desempenho',
      label: 'MEU DESEMPENHO',
      items: [
        {
          key: 'vendas',
          name: 'Vendas',
          icon: '/assets/icons/sidebar-icons/vendas.png',
          children: [
            { key: 'vendas-hoje', name: 'Hoje', url: '/vendas-hoje' },
            { key: 'vendas-fechadas', name: 'Fechadas', url: '/vendas-fechadas' }
          ]
        },
        {
          key: 'repasses',
          name: 'Repasses',
          url: '/conta',
          icon: '/assets/icons/repasse.png'
        },
        {
          key: 'conciliacao',
          name: 'Conciliação',
          url: '/conciliacao',
          icon: '/assets/icons/sidebar-icons/consiliacao.png'
        },
        {
          key: 'antecipacao',
          name: 'Antecipação',
          url: '/antecipacao',
          icon: '/assets/icons/sidebar-icons/antecipacao.png'
        }
      ]
    },
    {
      key: 'oferta-e-sua',
      label: 'A OFERTA É SUA',
      items: [
        {
          key: 'como-funciona',
          name: 'Como funciona',
          url: '/descubra-sua-oferta',
          icon: '/assets/icons/sidebar-icons/oferta-sua.png'
        },
        ...(hasDesconto
          ? [
              {
                key: 'desconto',
                name: 'Desconto',
                icon: '/assets/icons/desconto.png',
                children: [
                  {
                    key: 'desconto-criar',
                    name: 'Criar oferta',
                    url: '/oferta-e-sua/selecionar-tipo-de-oferta/criar-desconto'
                  },
                  {
                    key: 'desconto-acompanhar',
                    name: 'Acompanhar desempenho',
                    url: '/oferta-e-sua/selecionar-tipo-de-oferta/lista-oferta?tab=0'
                  }
                ]
              }
            ]
          : []),
        ...(hasCashback
          ? [
              {
                key: 'cashback',
                name: 'Cashback',
                icon: '/assets/icons/cashback.png',
                children: [
                  {
                    key: 'cashback-acompanhar',
                    name: 'Acompanhar desempenho',
                    url: '/oferta-e-sua/selecionar-tipo-de-oferta/lista-oferta?tab=1'
                  }
                ]
              }
            ]
          : [])
      ]
    },
    ...(hasPromocaoNacional
      ? [
          {
            key: 'promocao-nacional',
            label: 'PROMOÇÃO NACIONAL',
            items: [
              {
                key: 'promocao-nacional-acompanhar',
                name: 'Acompanhar campanha',
                url: '/promocao-nacional',
                icon: '/assets/icons/sidebar-icons/oferta-sua.png'
              }
            ]
          }
        ]
      : []),
    {
      key: 'conta',
      label: 'CONTA',
      items: [
        ...(storeName
          ? [
              {
                key: 'store-name',
                name: storeName,
                icon: '/assets/icons/nome_posto_logado.png',
                isDisplay: true
              }
            ]
          : []),
        {
          key: 'dados-cadastrais',
          name: 'Dados cadastrais',
          url: '/meus-dados',
          icon: '/assets/icons/dados_cadastrais.png'
        },
        {
          key: 'tarifas',
          name: 'Tarifas',
          url: '/financeiro',
          icon: '/assets/icons/sidebar-icons/financeiro.png'
        },
        {
          key: 'central-ajuda',
          name: 'Central de ajuda',
          url: '/perguntas-frequentes',
          icon: '/assets/icons/sidebar-icons/central-ajuda.png'
        },
        ...(isReadonly
          ? [
              {
                key: 'acessar-outro-cnpj',
                name: 'Acessar outro CNPJ',
                icon: '/assets/icons/acessar-cnpj.png',
                url: '/busca-parceiro'
              }
            ]
          : []),
        {
          key: 'sair',
          name: 'Sair da conta',
          icon: '/assets/icons/sair-conta.png',
          action: 'logout'
        }
      ]
    }
  ]
})

export const buildLegacyNavigationStatic = ({ hasDesconto, hasCashback, hasPromocaoNacional } = {}) => {
  const items = [
    {
      name: 'Vendas de hoje',
      url: '/vendas-hoje',
      icon: 'fa fa-shopping-basket',
      badge: { variant: 'info' }
    },
    {
      name: 'Vendas fechadas',
      url: '/vendas-fechadas',
      icon: 'fa fa-shopping-basket',
      badge: { variant: 'info' }
    },
    {
      name: 'Conta',
      url: '/conta',
      icon: 'fa fa-balance-scale',
      badge: { variant: 'info' }
    },
    {
      name: 'Conciliação',
      url: '/conciliacao',
      icon: 'fa fa-balance-scale',
      badge: { variant: 'info' }
    }
  ]

  if (hasDesconto || hasCashback) {
    items.push({
      name: 'A Oferta é Sua',
      url: '/oferta-e-sua',
      icon: 'fa fa-balance-scale',
      badge: { variant: 'info' }
    })
  }

  if (hasPromocaoNacional) {
    items.push({
      name: 'Promoção Nacional',
      url: '/promocao-nacional',
      icon: 'fa fa-flag',
      badge: { variant: 'info' }
    })
  }

  items.push({
    name: 'Antecipação',
    url: '/antecipacao',
    icon: 'fa fa-money-bill-wave',
    badge: { variant: 'info' }
  })

  return { items }
}

export default { sections: buildNavigation().sections }
